(() => {
  function initFaq(root) {
    const questions = root.querySelectorAll('.jb-faq-question');

    questions.forEach((question) => {
      const answerId = question.getAttribute('aria-controls');
      const answer = answerId ? root.querySelector(`#${CSS.escape(answerId)}`) : null;
      if (!answer) return;

      question.addEventListener('click', () => {
        const isOpen = question.getAttribute('aria-expanded') === 'true';
        question.setAttribute('aria-expanded', String(!isOpen));
        answer.hidden = isOpen;
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-jb-faq-section]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
